var imagesWithOriginalSrc = new RegExp('<IMG[^>]+?ORIGINALSRC\\s*=\\s*"[\\s\\S]+?"[\\s\\S]*?>', 'gim');
var srcAttribute = new RegExp('\\sSRC\\s*=\\s*"[\\s\\S]+?"', 'im');
export default function removeSrcAttributeFromInlineImages(html) {
    if (html) {
        return html.replace(imagesWithOriginalSrc, function (imgTagStr) {
            return imgTagStr.replace(srcAttribute, '');
        });
    }
    else {
        return html;
    }
}
//# sourceMappingURL=removeSrcAttributeFromInlineImages.js.map